import LayoutChild from "@/layouts/LayoutChild.vue";
// import LayoutArticle from "@/layouts/LayoutArticle.vue";

export default [{
  path: "/topic",
  name: "topic",
  meta: {
    title: "专题专栏",
  },
  component: LayoutChild,
  // component: LayoutArticle,
  redirect: "/topic/index",
  children: [{
    path: "index",
    name: "topic_index",
    meta: {
      title: "专题专栏",
    },
    component: () => import("@/views/topic/index.vue"),
  },
  {
    path: "category",
    name: "topic_category",
    meta: {
      title: "",
      icon: require('@/assets/images/icons/lianzhneg.png')
    },
    component: () => import("@/views/topic/category.vue"),
  },
  {
    path: "list",
    name: "topic_list",
    meta: {
      title: "",
    },
    component: () => import("@/views/topic/list.vue"),
  },
  {
    path: "detail",
    name: "topic_detail",
    meta: {
      title: "文章详情",
    },
    component: () => import("@/views/topic/detail.vue"),
  }
  ]
}];